<script setup lang="ts">
import HeaderMain from "../Headers/HeaderMain.vue";
import FooterMain from "../Footers/FooterMain.vue";
import SidebarMain from "../Sidebars/SidebarMain.vue";
import AbortModal from "../Modal/AbortModal.vue";
import NotificationToast from "../Notifications/NotificationToast.vue";
import { onUnmounted, ref } from "vue";
import { useTasksStore } from "@/stores/v2";
import router from "@/router/v2";

// State
const isSidebarActive = ref(false);
const abortModal = ref(false);
const sidebarRef = ref<Node | null>(null);
const tasksStore = useTasksStore();
// Methods
const sidebarToggler = () => {
  isSidebarActive.value = !isSidebarActive.value;
};

// Close the sidebar when clicking outside
const handleOutsideClick = (event: MouseEvent) => {
  if (
    isSidebarActive.value &&
    sidebarRef.value &&
    !sidebarRef.value.contains(event.target as Node)
  ) {
    isSidebarActive.value = false;
  }
};

const toggleAbortModal = () => {
  if (tasksStore.activeTask) {
    return (abortModal.value = !abortModal.value);
  }

  router.push("/select-site");
};

// Listen for clicks on the body element
document.body.addEventListener("click", handleOutsideClick, true);

// Cleanup the event listener when the component is unmounted
onUnmounted(() => {
  document.body.removeEventListener("click", handleOutsideClick);
});
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <HeaderMain
        :class="{ 'blur-sm': isSidebarActive }"
        class="w-full transition-all duration-300 flex-shrink-0 relative z-10"
        :sidebarToggler="sidebarToggler"
    />
    <div class="flex-grow flex relative z-10">
      <div
          :class="{ 'blur-sm': isSidebarActive }"
           class="container transition-all duration-300 mx-auto py-8 p-4 overflow-y-auto max-h-[calc(100vh-10rem)]"
      >
        <slot name="mainArea"></slot>
      </div>
      <AbortModal :showModal="abortModal" :toggleAbortModal="toggleAbortModal" />
    </div>
    <div
        class="fixed flex justify-end right-[-100%] z-20 top-0 h-screen w-screen overflow-x-hidden transition-all duration-300"
        :class="{ 'right-[0%]': isSidebarActive }"
    >
      <div class="h-full fixed" ref="sidebarRef">
        <SidebarMain
            class="right-[-300px] shadow-md py-10 px-4 bg-primary w-[300px] h-full transition-all duration-500 ease-in-out"
            :class="{ 'right-0': isSidebarActive }"
            :showModal="abortModal"
            :toggleAbortModal="toggleAbortModal"
        />
      </div>
    </div>
    <FooterMain
        :class="{ 'blur-sm': isSidebarActive }"
        class="w-full transition-all duration-300 flex-shrink-0 relative z-10"
    />
    
    <!-- Global Notifications -->
    <NotificationToast />
  </div>
</template>
